import { render } from "./VendorModel.vue?vue&type=template&id=15166ad9&scoped=true"
import script from "./VendorModel.vue?vue&type=script&lang=js"
export * from "./VendorModel.vue?vue&type=script&lang=js"

import "./VendorModel.vue?vue&type=style&index=0&id=15166ad9&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15166ad9"]])

export default __exports__